import { DeviceDTO } from '@eppendorf/vnls-device-service-utils';
import { Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ButtonV2 } from '@eppendorf/vnls-react-components-preview';
import { useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useAutoFocus } from '$shared/custom-hooks/useAutoFocus';
import { capitalize } from '$shared/utils/string.utils';

import { useDeviceType } from '$components/app-config/useDeviceType';

export interface AddedScreenProps {
  device?: DeviceDTO;
}

export function SuccessScreen({ device }: AddedScreenProps) {
  const { t } = useTranslation();
  const pairLaterButtonRef = useRef<null | HTMLButtonElement>(null);

  useAutoFocus(pairLaterButtonRef);

  const technicalDeviceType = useDeviceType(device);
  const translatedDeviceType = technicalDeviceType
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any -- translation keys are dynamic here
      t(`deviceType.${technicalDeviceType}` as any)
    : t('deviceDetail.fallbackHeadlineNameEmpty');
  const deviceType = capitalize(translatedDeviceType);

  return (
    <>
      <div className="flex flex__dir--column flex__ai--center text-align-center">
        <Icon
          name="success"
          className="bg-green-500 m-bottom-xxl"
          size={IconSizeClasses.XLarge}
        />
        <Dialog.Title>{t('addDevice.isAdded')}</Dialog.Title>
        <span>
          <Trans
            i18nKey="addDevice.successInfo"
            values={{
              serialNumber: device?.serialNumber,
              type: deviceType,
            }}
            components={{ strong: <span className="font-weight-bold" /> }}
          />
        </span>
      </div>
      <Dialog.Actions className="m-top-xxxl">
        <Dialog.Close>
          <ButtonV2 className="btn--solid">{t('shared.close')}</ButtonV2>
        </Dialog.Close>
      </Dialog.Actions>
    </>
  );
}
